export class User {
  nombre: string = '';
  email: string = '';
  /**
	 * Token JWT obtenido al loguearse con exito en la aplicación.
	 * 
	 * Es utilizado para hacer requests autenticados a API.
	 */
  token_auth: string = '';

  constructor() {
    this.token_auth = '';
  }
}